import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { useEffect, useRef } from 'react';

const HighlightKeywordsExample = ({ pdfUrl, keywords = [] }) => {
    const isDocumentLoaded = useRef(false);
    const pendingKeywords = useRef([]);

    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        toolbarPlugin: {
            searchPlugin: {
                onHighlightKeyword: (props) => {
                    props.highlightEle.style.backgroundColor = 'rgba(255, 240, 0, 0.4)';
                },
            },
        },
    });

    const { searchPluginInstance } = defaultLayoutPluginInstance.toolbarPluginInstance;

    const runHighlight = (kws) => {
        const safe = Array.isArray(kws) ? kws : [];
        const keywordObjects = safe
            .filter(kw => typeof kw === 'string' && kw.trim().length > 0)
            .map(kw => ({ keyword: kw, matchCase: false }));
        if (keywordObjects.length > 0) {
            searchPluginInstance.highlight(keywordObjects);
        }
    };

    const handleDocumentLoad = () => {
        isDocumentLoaded.current = true;
        if (pendingKeywords.current.length > 0) {
            setTimeout(() => runHighlight(pendingKeywords.current), 400);
        }
    };

    useEffect(() => {
        const safe = Array.isArray(keywords) ? keywords : [];
        if (safe.length === 0) return;

        if (isDocumentLoaded.current) {
            setTimeout(() => runHighlight(safe), 400);
        } else {
            pendingKeywords.current = safe;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [keywords]);

    return (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Viewer
                fileUrl={pdfUrl}
                plugins={[defaultLayoutPluginInstance]}
                onDocumentLoad={handleDocumentLoad}
            />
        </Worker>
    );
};

export default HighlightKeywordsExample;